import { fetchWithFaseAuth } from './auth-service';

function getFaseFleet(customerCode) {
  const paramPath = customerCode ? `customerCode/${customerCode}` : '';
  return fetchWithFaseAuth(`/api/faseFleet/${paramPath}`);
}

function getFaseBox(serial) {
  const paramPath = serial ? `serial/${serial}` : '';
  return fetchWithFaseAuth(`/api/faseBox/${paramPath}`);
}

function getFaseCustomers() {
  return fetchWithFaseAuth('/api/faseFleet/customers');
}

function getTheme(customerCode) {
  const path = customerCode ? `/api/customer/${customerCode}` : '/api/customer';
  return fetchWithFaseAuth(path);
}

export { getFaseFleet, getFaseBox, getTheme, getFaseCustomers };
